import { Box, Flex, Text, Button, Card, Grid } from '@radix-ui/themes';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { subscriptionService } from '../../services/subscriptionService';
import CourseView from '../common/CourseView';
import { toast } from 'react-toastify';

const StudentCourseSetup = ({ editing, onSubscribed, onCanceled }) => {
    const student = useSelector((state) => state.studentAccount.details);
    const school = useSelector((state) => state.studentAccount.school);
    const [availableCourses, setAvailableCourses] = useState({
        school: [],
        recommended: [],
        ai: []
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAvailableCourses = async () => {
            try {
                setIsLoading(true);
                const courses = await subscriptionService.getAvailableCourses({
                    subjectId: editing,
                    levelId: student.current_level,
                    schoolId: school?.id || null
                });
                console.log('courses>>>>>>>>>>>>>>', courses);
                setAvailableCourses(courses);
            } catch (err) {
                setError('Failed to load available courses');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchAvailableCourses();
    }, [editing]);

    const handleSubscribe = async (course) => {
        try {
            const updated_subscription = await subscriptionService.updateSubscription(editing, course.id);
            console.log('updated_subscription>>>>>>>>>>>>>>', updated_subscription);
            toast.success(updated_subscription.message);
            onSubscribed(updated_subscription.subscription);
        } catch (err) {
            setError('Failed to update subscription');
            console.error(err);
        }
    };

    if (isLoading) {
        return <Text>Loading available courses...</Text>;
    }

    if (error) {
        return <Text color="red">{error}</Text>;
    }

    return (
        <Box width="100%">
            <Flex direction="column" gap={{ initial: '3', sm: '4' }}>
                {availableCourses.school.length > 0 && (
                    <Box>
                        <Text
                            size={{ initial: '2', sm: '3' }}
                            weight="bold"
                            mb={{ initial: '2', sm: '3' }}
                        >
                            Courses from your school
                        </Text>
                        {availableCourses.school.map((course) => (
                            <CourseView
                                key={course.id}
                                course={course}
                                onSelect={() => handleSubscribe(course)}
                                style={{
                                    minHeight: '150px',
                                    touchAction: 'manipulation'
                                }}
                            />
                        ))}
                    </Box>
                )}

                {availableCourses.recommended.length > 0 && (
                    <Box>
                        <Text size="2" weight="bold" mb="2" as="p">Recommended Courses</Text>
                        {availableCourses.recommended.map((course) => (
                            <CourseView
                                key={course.id}
                                course={course}
                                onSelect={() => handleSubscribe(course)}
                            />
                        ))}
                    </Box>
                )}

                {availableCourses.school.length === 0 &&
                    availableCourses.recommended.length === 0 && (
                        <Text
                            color="gray"
                            align="center"
                            py={{ initial: '3', sm: '4' }}
                            size={{ initial: '2', sm: '3' }}
                        >
                            No courses available for your level
                        </Text>
                    )}
            </Flex>
        </Box>
    );
};

export default StudentCourseSetup;
